import WorkspacePage from './workspace/page'
import HistoryPage from './history/page'
import { permissions } from '../../types/authorization'
import type { ProtectedRouteDescriptor } from '../../routes/types'

export const practiceAgentRouteDescriptors: ProtectedRouteDescriptor[] = [
  {
    key: 'reports-workspace',
    path: 'reports/workspace/:reportBuilderId',
    element: <WorkspacePage />,
    access: { anyOf: [permissions.viewNotification] },
  },
  {
    key: 'reports-workspace-group',
    path: 'reports/workspace/group/:reportBuilderGroupId',
    element: <WorkspacePage />,
    access: { anyOf: [permissions.viewNotification] },
  },
  {
    key: 'reports-workspace-history',
    path: 'reports/workspace/history',
    element: <HistoryPage />,
    access: { anyOf: [permissions.viewNotification] },
  },
]
